// Others
import {
  IBodyChangeStatusOrder,
  IBodySplitOrder,
  IOrder,
  IOrderCostingDetail,
  IOrderDetail,
  IOrderDetailInvoice,
  IOrderDetailOverbooked,
  IOrderEventList,
  IOrderSplit,
  IParamQueryOrder,
  IParamQueryOrderDetail,
  IParamQueryOrderSplit,
  IQueryParamOrderEvent,
} from '~/utils/interface/order';
import axiosClient from './axiosClient';
import { urlApiOrder } from '~/utils/constants/apis';
import { IBodyUpdate, IFileItem } from '~/utils/interface/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { CONTENT_TYPE_FORM_DATA, EMPTY_STRING } from '~/utils/constants/common';
import { IActivity } from '~/utils/interface/activity';

const orderApi = {
  getListOrder: (params: IParamQueryOrder) => {
    const url = urlApiOrder.getListOrder;
    return axiosClient.get<IBaseResponse<IListDataResponse<IOrder[]>>>(url, { params });
  },

  getOrderDetail: (params: IParamQueryOrderDetail) => {
    const url = urlApiOrder.getDetailOrder(params);
    return axiosClient.get<
      IBaseResponse<
        | IListDataResponse<IFileItem[]>
        | IOrderCostingDetail
        | IOrderDetail
        | IOrderDetailOverbooked
        | IOrderDetailInvoice
        | IListDataResponse<IActivity[]>
      >
    >(url, {
      params: params.query,
    });
  },

  deleteOrder: (id: string) => {
    const url = urlApiOrder.deleteOrder(id);
    return axiosClient.delete<IBaseResponse>(url);
  },

  getListOrderEvent: (params: IQueryParamOrderEvent) => {
    const url = urlApiOrder.getListOrderEvent;
    return axiosClient.get<IBaseResponse<IOrderEventList[] | IListDataResponse<IOrderEventList[]>>>(url, { params });
  },

  convertOrderToJob: (orderId: string) => {
    const url = urlApiOrder.convertOrderToJob(orderId);
    return axiosClient.post<IBaseResponse>(url);
  },

  getOrderSplit: (params: IParamQueryOrderSplit) => {
    const url = urlApiOrder.getOrderSplit(params?.orderId || EMPTY_STRING);
    delete params?.orderId;
    return axiosClient.get<IBaseResponse<IOrderSplit>>(url, { params });
  },

  splitOrder: (payload: IBodySplitOrder) => {
    const { jobs, orderId } = payload;

    const url = urlApiOrder.splitOrder(orderId);
    return axiosClient.post<IBaseResponse>(url, jobs);
  },

  updateOrder: (params: IBodyUpdate<FormData>) => {
    const { id, body } = params;
    const url = urlApiOrder.updateOrder(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  revertToQuote: (id: string) => {
    const url = urlApiOrder.revertToQuote(id);
    return axiosClient.post<IBaseResponse>(url);
  },

  sendMailOrder: (params: IBodyUpdate<FormData>) => {
    const { id, body } = params;

    const url = urlApiOrder.sendMailOrder(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  changeStatusOrder: (params: IBodyUpdate<IBodyChangeStatusOrder>) => {
    const { id, body } = params;

    const url = urlApiOrder.changeStatusOrder(id);
    return axiosClient.put<IBaseResponse>(url, body);
  },
};

export default orderApi;
